import { Roles } from '@/entities/roles'
import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { BaseCard } from '@/shared/components'
import React from 'react'

type Props = {
  id?: string
  title: string
  type: 'requisite' | 'device' | 'deal' | 'disput'
  children: React.ReactNode
  userRole?: Roles
}

export const ItemBaseBlock = ({ title, children, id, type, userRole = Roles.Trader }: Props) => {
  const isTrader = userRole === Roles.Trader

  const url =
    type === 'deal'
      ? '/deals'
      : type === 'device'
        ? '/devices'
        : type === 'disput'
          ? '/orders'
          : '/requisites'

  return (
    <BaseCard variant="primary" className="flex flex-col gap-6 px-6 py-8 md:pr-[120px]">
      {isTrader && (
        <Link to={`${url}/${id}`} className="flex items-center gap-2">
          <h3>{title}</h3>
          <ChevronRight />
        </Link>
      )}
      {!isTrader && <h3>{title}</h3>}
      {children}
    </BaseCard>
  )
}
